import { Card, Timeline, Typography, Button } from "antd";
//import React, { useMemo } from "react";
import Minter from "../components/Minter";
import MintNFT from "../components/MintNft";
import HashlipsLogo from "components/HashlipsLogo";
import ChainlinkLogo from "components/ChainlinkLogo";
import TokenPricing from "./TokenPricing";
import PresaleDetail from "./PresaleDetails";
import GiveawayNFT from "./GiveawayNFT";
import Account from "components/Account/Account";
import Chains from "./Chains/Chains";
//import MintNFT from "./MintNft";

const { Text } = Typography;

const styles = {
  contentnft: {
    display: "flex",
    paddingBottom: "25px",
    paddingLeft: "15px",
    paddingRight: "15px",
    gap: "25px",
    marginTop: "-30px",
  },

  title: {
    fontSize: "14px",
    fontWeight: "700",
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
  },
  itemdot: {
    fontWeight: "600",
    fontSize: "17px",
  },
  text: {
    fontSize: "12px",
    fontWeight: "400",
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
  },
  poweredby: {
    marginTop: "25px",
    marginBottom: "5px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "400",
    color: "#2655DD",
  },
  card: {
    color: "white",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    border: "0px solid transparent",
    borderRadius: "0.5rem",
    background:
      "linear-gradient(222deg, rgb(31, 32, 48) 0%, rgba(26,27,38,1) 31%, rgb(30, 32, 44) 54%, rgba(26,26,37,1) 100%)",
  },
  timeline: {
    marginBottom: "-45px",
    color: "white",
  },
};

export const Chainlink = () => (
  <div style={styles.ChainContainer}>
    <ChainlinkLogo image="https://storageapi2.fleek.co/65baa672-f449-45c2-ab44-13cf8312b581-bucket/securedbychainlink.svg" />
  </div>
);

export const Hashlips = () => (
  <div style={styles.LipsContainer}>
    <HashlipsLogo image="https://storageapi2.fleek.co/65baa672-f449-45c2-ab44-13cf8312b581-bucket/hashlips.svg" />
  </div>
);

export default function NFTLottery() {
  return (
    <div style={styles.contentnft}>
      <Card
        style={styles.card}
        title={
          <>
            💎 <Text style={styles.title}>Mint Cosmonaut NFT</Text>
          </>
        }
      >
        <MintNFT />
      </Card>

      <Card
        style={styles.card}
        title={
          <>
            <Text style={styles.title}>Cosmonaut NFT gives you money!</Text>
          </>
        }
      >
        <Timeline mode="center" style={styles.timeline}>
          <Minter />
          <div style={styles.poweredby}>
            🎲 <Text style={styles.title}>Verifiable Random Function</Text>
          </div>
          <Chainlink />
          <GiveawayNFT />
          {/*  <div style={styles.poweredby}>
            🎲 <Text style={styles.title}>Inspired By/</Text>
          </div>
          <Hashlips />*/}
        </Timeline>
      </Card>

      <div>
        <Card
          style={{ marginTop: "0px", ...styles.card }}
          title={
            <>
              {" "}
              <Text style={styles.title}>How does it work? </Text>
            </>
          }
        >
          <Timeline mode="left" style={styles.timeline}>
            <Timeline.Item dot="1" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>Every time YOU Mint, </b> your wallet address will be{" "}
                <b>added</b> to the <b>Cosmonauts Gift List.</b> This means that{" "}
                <b>more Mints = More chances to Win.</b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="2" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>Each and Every time someone ELSE Mints,</b> a <b>wallet</b>{" "}
                from the <b>Cosmonauts Gift List</b> will be selected{" "}
                <b>RANDOMLY</b> to get a <b>20% NFT value back.</b> (999 prizes
                will be given RANDOMLY for a grand total of 50 BNB)
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="3" style={styles.itemdot}>
              <Text style={styles.text}>
                WHEN NFT NUMBERS <b>250, 500, 750, AND 1000 ARE MINTED,</b> A
                RANDOM WALLET WILL BE SELECTED FROM THE COSMONAUTS GIFT LIST,{" "}
                <b>TO GET A 25 BNB PRIZE!</b> (4 PRIZES OF 25 BNB WILL BE GIVEN
                RANDOMLY FOR A grand TOTAL OF <b>100 BNB</b>)
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="4" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>CONTRACT LIQUIDITY LOCKED.</b> THIS WILL ASSURE THERE WILL BE
                NO WITHDRAWALS FROM THE CONTRACT,{" "}
                <b>
                  THIS WAY securing ENOUGH BALANCE TO PAY FOR ALL THE PRIZES.{" "}
                </b>{" "}
              </Text>
            </Timeline.Item>
          </Timeline>
        </Card>

        <Card
          style={{ marginTop: "20px", ...styles.card }}
          title={
            <>
              💎{" "}
              <Text style={styles.title}>
                {" "}
                Why should I hold Destiny Governance NFTs?
              </Text>
            </>
          }
        >
          <Timeline mode="left" style={styles.timeline}>
            <Timeline.Item dot="1" style={styles.itemdot}>
              <Text style={styles.text}>
                <b>
                  🔥 GET 30% DISCOUNT IN FTL PRESALE! PAY AN EFFECTIVE PRICE OF
                  5 BUSD PER EACH FTL YOU BUY, IF YOU HOLD A GOVERNANCE NFT!
                </b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="2" style={styles.itemdot}>
              <Text style={styles.text}>
                Stake and Hold your governance NFTS for <b>passive income</b>
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="3" style={styles.itemdot}>
              <Text style={styles.text}>
                ACCESS to PRIVATE AREA WHERE DAO DECISIONS ARE BEING MADE.{" "}
              </Text>
            </Timeline.Item>
            <Timeline.Item dot="4" style={styles.itemdot}>
              <Text style={styles.text}>
                ACCESS TO EXCLUSIVE GIVEAWAYS AND PRESALES IN THE UPCOMING NFT
                LAUNCHPAD
              </Text>
            </Timeline.Item>
          </Timeline>
        </Card>
      </div>
    </div>
  );
}
